/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import {
  Flex,
  Heading,
  useDisclosure,
  Spinner,
  Box,
  HStack,
  Stack,
  Switch,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import _ from 'lodash';
import { Text } from '@mybridge/ui/text';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useRouter } from 'next/router';
import { useToast } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import {
  EarthGlobeIcon,
  TeamIcon,
  OnlyMeLockIcon,
  BackArrow,
} from '@mybridge/icons';
import { InfoLinedIcon } from '@mybridge/icons/CampaignIcon';
import { AudienceFriendsModal } from 'v4/snippets/settings/component/audience-modal-friends';
import { AudienceFriendsListModal } from 'v4/snippets/settings/component/audience-modal-friends-list';
import { setAccountPermissions, getUserProfileInfo } from 'v4/store/actions/user-profile.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
export default function VisibilityAudience({ setSelectedComponent }) {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const router = useRouter();
  const toast = useToast();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState(null);
  const [googleLinked, setGoogleLinked] = useState(false);
  const userFriendsPermDisc = useDisclosure();
  const userFriendsListPermDisc = useDisclosure();

  const trackVisibilityPageVisit = () => {
    const userSlug = userProfileInfo?.slug;
    if (!userSlug) return;
  
    trackEvent(ANALYTICS_EVENTS.AudienceAndVisibility, userSlug, {
      page_path: router.asPath,
      page_title: 'Audience and Visibility',
      timestamp: new Date().toISOString()
    });
  };
    
  useEffect(() => {
    trackVisibilityPageVisit();
  }, []);
  

  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('createPost.everyone') || 'Everyone',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" color="#5B5B5B" />,
          text: t('profileDetails.myNetwork') || 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: t('profileDetails.onlyMe') || 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('createPost.everyone') || 'Everyone',
        };
    }
  };

  const renderFriendsListSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('settingsAudience.1stDegree') || '1st Degree',
        };
      case 2:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: t('profileDetails.onlyMe') || 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('settingsAudience.1stDegree') || '1st Degree',
        };
    }
  };

  const friendReqOption = _.get(
    userProfileInfo,
    'field_audience_visibility.WHO_CAN_SEND_FRIEND_REQ'
  );
  const friendListOption = _.get(
    userProfileInfo,
    'field_audience_visibility.WHO_CAN_SEE_FRIENDS'
  );
  const mentionAndTagsValue = _.get(
    userProfileInfo,
    'field_audience_visibility.MENTIONS_AND_TAGS'
  );

  const updateTagsMentionsOption = (e) => {
    const payload = {
      attribute: 'MENTIONS_AND_TAGS', // WHO_CAN_SEND_FRIEND_REQ | WHO_CAN_SEE_FRIENDS | MENTIONS_AND_TAGS
      audience: e.target.checked,
    };
    dispatch(setAccountPermissions(payload)).then((res) => {
      if (res?.payload) {
        dispatch(getUserProfileInfo());
      }
    });
  };


  return (
    <AuthenticatedProviders>
      <Box className="user-settings--integration" p={["15px",""]} display="flex" flexDirection="column" gap="60px">
        <Box 
          display="flex"
          flexDirection="column"
          gap="24px"
        >
          <Heading
            as="h4"
            size="md"
            // p={['2%', '0 0 10px']}
          >
            <HStack>
              <Text fontSize="20px" fontWeight="400" color="brandPrimary.500">{t('settingsAudience.howPeopleFindYou') || "How people find and contact you"}</Text>
            </HStack>
          </Heading>

          <Stack spacing="24px">
            {/* Who can send you friend requests? */}
            <HStack justifyContent="space-between">
              {/* <Text fontSize="14px" color="#5B5B5B" fontWeight="400" maxW="563px" w="100%">{t('settingsAudience.whoCanSendRequests') || "Who can send you friend requests?"}</Text> */}
              <HStack spacing={2} maxW="563px" w="100%">
                <Text fontSize="14px" color="#5B5B5B" fontWeight="400">{t('settingsAudience.whoCanSendRequests') || "Who can send you friend requests?"}</Text>
                <Popover trigger="hover" placement="top" isLazy>
                  <PopoverTrigger>
                    <Box as="button" type="button" cursor="pointer" display="inline-flex" alignItems="center" _focus={{ outline: 'none' }}>
                      <InfoLinedIcon width="16px" height="16px" color="#9C9C9C" />
                    </Box>
                  </PopoverTrigger>
                  <PopoverContent maxW="280px" borderRadius="8px" _focus={{ outline: 'none' }} boxShadow="md">
                    <PopoverArrow />
                    <PopoverBody color="#5B5B5B" fontSize="12px" fontWeight="400">
                      {"Control who can send you connection requests on myBridge (Everyone or myNetwork)."}
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
              </HStack>
              <Button
                type="button"
                borderRadius="30px"
                bg="#E4E6EB"
                color="#5B5B5B"
                maxW={'110px'}
                width="140px"
                height="36px"
                fontSize="14px"
                onClick={() => {
                  userFriendsPermDisc.onOpen();
                }}
                leftIcon={renderPermissionSwitch(friendReqOption)?.icon}
              >
                {renderPermissionSwitch(friendReqOption)?.text}
              </Button>
            </HStack>

            {/* Who can see your friend list? */}
            <HStack justifyContent="space-between">
              {/* <Text fontSize="14px" color="#5B5B5B" fontWeight="400" maxW="563px" w="100%">{t('settingsAudience.whoCanSeeFriendList') || "Who can see your friend list?"}</Text> */}
              <HStack spacing={2} maxW="563px" w="100%">
                <Text fontSize="14px" color="#5B5B5B" fontWeight="400">{t('settingsAudience.whoCanSeeFriendList') || "Who can see your friend list?"}</Text>
                <Popover trigger="hover" placement="top" isLazy>
                  <PopoverTrigger>
                    <Box as="button" type="button" cursor="pointer" display="inline-flex" alignItems="center" _focus={{ outline: 'none' }}>
                      <InfoLinedIcon width="16px" height="16px" color="#9C9C9C" />
                    </Box>
                  </PopoverTrigger>
                  <PopoverContent maxW="280px" borderRadius="8px" _focus={{ outline: 'none' }} boxShadow="md">
                    <PopoverArrow />
                    <PopoverBody color="#5B5B5B" fontSize="12px" fontWeight="400">
                      {"Control who can view your connections list on your profile (1st Degree connections or Only me)."}
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
              </HStack>
              <Button
                type="button"
                borderRadius="30px"
                maxW={'110px'}
                bg="#E4E6EB"
                color="#5B5B5B"
                width="140px"
                height="36px"
                fontSize="14px"
                onClick={() => {
                  userFriendsListPermDisc.onOpen();
                }}
                leftIcon={renderFriendsListSwitch(friendListOption)?.icon}
              >
                {renderFriendsListSwitch(friendListOption)?.text}
              </Button>
            </HStack>
          </Stack>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          gap="24px"
        >
          <Heading
            as="h4"
            size="md"
            // p={['2%', '0 0 10px']}
          >
            <HStack>
              <Text fontSize="20px" fontWeight="400" color="brandPrimary.500">{t('settingsAudience.mentionsOrTags') || "Mentions or Tags"}</Text>
            </HStack>
          </Heading>

          <Stack spacing="24px">
            {/* Mentions or Tags */}
            <Stack  display="flex"
            flexDirection="column"
            gap="16px">
              <Box display="flex" justifyContent="space-between">
                <Text fontSize="16px" color="#5B5B5B" fontWeight="400">{t('settingsAudience.mentionsOrTags') || "Mentions or Tags"}</Text>
                <Switch
                  isChecked={mentionAndTagsValue}
                  onChange={(e) => updateTagsMentionsOption(e)}
                />
              </Box>
              {/* <Text fontSize="12px" color="#5B5B5B" fontWeight="400" width={[null, "696px" ]}height="15px"> */}
              <Text fontSize="12px" color="#5B5B5B" fontWeight="400" maxW="696px" w="100%">
                {t('settingsAudience.mentionsExample') || "Example of mentions include tagging you in posts or photos. You can control the visibility of your existing mentions."}
              </Text>

              {/* <Button
                type="button"
                // onClick={() => {audienceDisc.onOpen(); setPermissionValue('profile_intro')}}
                leftIcon={renderPermissionSwitch(introValue)?.icon}
              >
                {renderPermissionSwitch(introValue)?.text}
              </Button> */}
            </Stack>
          </Stack>
        </Box>
      </Box>

      <AudienceFriendsModal {...userFriendsPermDisc} />
      <AudienceFriendsListModal {...userFriendsListPermDisc} />
    </AuthenticatedProviders>
  );
}
